<template>
  <div>
    <template v-if="panel === true">
      <div class="overflow-hidden">
        <v-bottom-navigation v-model="value" :input-value="active" color="primary" horizontal app fixed>
          <v-btn class="d-none">
            <span>Iddle </span>
            <v-icon>mdi-power-on</v-icon>
          </v-btn>

          <ButtonHover :small="false" :plain="false" :icons="['mdi-power']" :command="'power'" :span="$t('control.inverter.power')"> </ButtonHover>
          <ButtonHover :small="false" :plain="false" :icons="['mdi-menu']" :command="'mode'" :span="$t('control.inverter.mode')"> </ButtonHover>

          <v-menu open-on-hover top :offset-y="true">
            <template v-slot:activator="{ on, attrs }">
              <v-btn small class="ml-8" dark v-bind="attrs" v-on="on">
                <v-icon> mdi-arrow-up-thin </v-icon>
                <v-icon> mdi-white-balance-sunny </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="(item, index) in mppt" :key="index">
                <v-list-item-title>
                  <v-icon> mdi-white-balance-sunny </v-icon>
                  <b> MPPT {{ index + 1 }} </b>
                </v-list-item-title>

                <v-list-item-action> </v-list-item-action>

                <ButtonHover :small="true" :plain="true" :icons="['mdi-power-on']" :command="'mppt' + (parseInt(index) + 1).toString() + 'on'" :span="$t('control.inverter.on')"> </ButtonHover>
                <ButtonHover :small="true" :plain="true" :icons="['mdi-power-off']" :command="'mppt' + (parseInt(index) + 1).toString() + 'off'" :span="$t('control.inverter.off')"> </ButtonHover>
                <ButtonHover :small="true" :plain="true" :icons="['mdi-medical-bag']" :command="'clearerrormppt' + (parseInt(index) + 1).toString()" :span="$t('control.others.clearError')"> </ButtonHover>
                <ButtonHover :small="true" :plain="true" :icons="['mdi-restore']" :command="'mppt' + (parseInt(index) + 1).toString() + 'softreset'" :span="$t('control.others.reset')"> </ButtonHover>
              </v-list-item>
            </v-list>
          </v-menu>

          <ButtonHover :small="false" :plain="false" :icons="['mdi-power-on']" :command="'mppton'" :span="$t('control.inverter.on')"> </ButtonHover>
          <ButtonHover :small="false" :plain="false" :icons="['mdi-power-off']" :command="'mpptoff'" :span="$t('control.inverter.off')"> </ButtonHover>

          <!-- start of DABs -->
          <v-menu open-on-hover top :offset-y="true">
            <template v-slot:activator="{ on, attrs }">
              <v-btn small class="ml-8" dark v-bind="attrs" v-on="on">
                <v-icon> mdi-arrow-up-thin </v-icon>
                <v-icon> mdi-battery-medium </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="(item, index) in dab" :key="index">
                <v-list-item-title>
                  <v-icon> mdi-battery-medium </v-icon>
                  <b> BAT {{ index + 1 }} </b>
                </v-list-item-title>

                <v-list-item-action> </v-list-item-action>

                <ButtonHover :small="true" :plain="true" :icons="['mdi-power-on']" :command="'dab' + (parseInt(index) + 1).toString() + 'on'" :span="$t('control.inverter.on')"> </ButtonHover>
                <ButtonHover :small="true" :plain="true" :icons="['mdi-power-off']" :command="'dab' + (parseInt(index) + 1).toString() + 'off'" :span="$t('control.inverter.off')"> </ButtonHover>
                <ButtonHover :small="true" :plain="true" :icons="['mdi-medical-bag']" :command="'clearerrordab' + (parseInt(index) + 1).toString()" :span="$t('control.others.clearError')"> </ButtonHover>
                <ButtonHover :small="true" :plain="true" :icons="['mdi-battery-medium', 'mdi-restore']" :command="'dab' + (parseInt(index) + 1).toString() + 'softreset'" span="SOFT"> </ButtonHover>
                <ButtonHover :small="true" :plain="true" :icons="['mdi-battery-medium', 'mdi-restore']" :command="'dab' + (parseInt(index) + 1).toString() + 'hardreset'" span="HARD"> </ButtonHover>
              </v-list-item>
            </v-list>
          </v-menu>

          <ButtonHover :small="false" :plain="false" :icons="['mdi-power-on']" :command="'dabon'" :span="$t('control.inverter.on')"> </ButtonHover>
          <ButtonHover :small="false" :plain="false" :icons="['mdi-power-off']" :command="'daboff'" :span="$t('control.inverter.off')"> </ButtonHover>
          <!-- end of DABs-->

          <ButtonHover :small="false" :plain="false" :icons="['mdi-wrench']" :command="'servicemode'" :span="$t('control.others.service')"> </ButtonHover>
          <ButtonHover :small="false" :plain="false" :icons="['mdi-battery-heart']" :command="'format'" :span="$t('control.others.format')"> </ButtonHover>

          <v-menu open-on-hover top :offset-y="true">
            <template v-slot:activator="{ on, attrs }">
              <v-btn small class="ml-8" dark v-bind="attrs" v-on="on">
                <v-icon> mdi-arrow-up-thin </v-icon>
                <v-icon>mdi-wrench-clock</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item>
                <ButtonHover :small="true" :plain="true" :icons="['mdi-current-ac', 'mdi-restore']" :command="'invertersoftreset'" :span="'Soft'"> </ButtonHover>
                <ButtonHover :small="true" :plain="true" :icons="['mdi-current-ac', 'mdi-restore']" :command="'inverterhardreset'" :span="'Hard'"> </ButtonHover>
                <ButtonHover :small="true" :plain="true" :icons="['mdi-white-balance-sunny', 'mdi-restore']" :command="'mppthardreset'" :span="'Hard'"> </ButtonHover>
                <ButtonHover :small="true" :plain="true" :icons="['mdi-medical-bag']" :command="'clearerror'" :span="$t('control.others.clearError')"> </ButtonHover>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-bottom-navigation>
      </div>
    </template>
    <template v-else>
      <div class="ma-1 my-4">
        <v-sheet class="mx-auto" elevation="8">
          <v-slide-group v-model="model" class="pa-4 px-6" show-arrows>
            <v-slide-item v-slot="{ active, toggle }">
              <v-card :color="active ? 'primary' : 'grey lighten-1'" class="ma-2" height="64" width="64" @click="toggle">
                <v-row class="fill-height mt-1" align="center" justify="center">
                  <v-scale-transition>
                    <v-icon color="white" size="32">mdi-power</v-icon>
                  </v-scale-transition>
                </v-row>
              </v-card>
            </v-slide-item>

            <v-slide-item v-slot="{ active, toggle }">
              <v-card :color="active ? 'primary' : 'grey lighten-1'" class="ma-2" height="64" width="64" @click="toggle">
                <v-row class="fill-height mt-1" align="center" justify="center">
                  <v-scale-transition>
                    <v-icon color="white" size="32">mdi-white-balance-sunny</v-icon>
                  </v-scale-transition>
                </v-row>
              </v-card>
            </v-slide-item>

            <v-slide-item v-slot="{ active, toggle }">
              <v-card :color="active ? 'primary' : 'grey lighten-1'" class="ma-2" height="64" width="64" @click="toggle">
                <v-row class="fill-height mt-1" align="center" justify="center">
                  <v-scale-transition>
                    <v-icon color="white" size="32">mdi-weather-sunny</v-icon>
                  </v-scale-transition>
                </v-row>
              </v-card>
            </v-slide-item>

            <v-slide-item v-slot="{ active, toggle }">
              <v-card :color="active ? 'primary' : 'grey lighten-1'" class="ma-2" height="64" width="64" @click="toggle">
                <v-row class="fill-height mt-1" align="center" justify="center">
                  <v-scale-transition>
                    <v-icon color="white" size="32">mdi-battery-medium</v-icon>
                  </v-scale-transition>
                </v-row>
              </v-card>
            </v-slide-item>

            <v-slide-item v-slot="{ active, toggle }">
              <v-card :color="active ? 'primary' : 'grey lighten-1'" class="ma-2" height="64" width="64" @click="toggle">
                <v-row class="fill-height mt-1" align="center" justify="center">
                  <v-scale-transition>
                    <v-icon color="white" size="32">mdi-battery-arrow-down</v-icon>
                  </v-scale-transition>
                </v-row>
              </v-card>
            </v-slide-item>

            <v-slide-item v-slot="{ active, toggle }">
              <v-card :color="active ? 'primary' : 'grey lighten-1'" class="ma-2" height="64" width="64" @click="toggle">
                <v-row class="fill-height mt-1" align="center" justify="center">
                  <v-scale-transition>
                    <v-icon color="white" size="32">mdi-wrench</v-icon>
                  </v-scale-transition>
                </v-row>
              </v-card>
            </v-slide-item>
          </v-slide-group>

          <v-expand-transition>
            <v-sheet v-if="model != null" height="220" tile>
              <v-row class="fill-height" align="center" justify="center">
                <h3 class="text-h6">
                  <!-- Power, Mode-->
                  <template v-if="model == 0">
                    <v-row dense>
                      <v-col cols="12">
                        <ButtonHover :small="true" :plain="true" :icons="['mdi-power']" :command="'power'" :span="$t('control.inverter.power')"> </ButtonHover>
                        <ButtonHover :small="true" :plain="true" :icons="['mdi-menu']" :command="'mode'" :span="$t('control.inverter.mode')"> </ButtonHover>
                      </v-col>
                    </v-row>
                  </template>
                  <!-- MPPT Global -->
                  <template v-if="model == 1">
                    <v-row dense justify="center">
                      <v-col cols="12">
                        <ButtonHover :small="true" :plain="true" :icons="['mdi-power-on']" :command="'mppton'" :span="''"> </ButtonHover>
                        <ButtonHover :small="true" :plain="true" :icons="['mdi-power-off']" :command="'mpptoff'" :span="''"> </ButtonHover>
                      </v-col>
                    </v-row>
                  </template>
                  <!-- Single MPPTs -->
                  <template v-if="model == 2">
                    <v-row v-for="(item, index) in mppt" :key="index" dense justify="center">
                      <v-col cols="12">
                        <ButtonHover :small="true" :plain="true" :icons="['mdi-power-on']" :command="'mppt' + (parseInt(index) + 1).toString() + 'on'" :span="''"> </ButtonHover>
                        <ButtonHover :small="true" :plain="true" :icons="['mdi-power-off']" :command="'mppt' + (parseInt(index) + 1).toString() + 'off'" :span="''"> </ButtonHover>
                        <ButtonHover :small="true" :plain="true" :icons="['mdi-medical-bag']" :command="'clearerrormppt' + (parseInt(index) + 1).toString()" :span="''"> </ButtonHover>
                        <ButtonHover :small="true" :plain="true" :icons="['mdi-white-balance-sunny', 'mdi-restore']" :command="'mppt' + (parseInt(index) + 1).toString() + 'softreset'" :span="'SOFT'"> </ButtonHover>
                      </v-col>
                    </v-row>
                  </template>
                  <!-- DAB Global-->
                  <template v-if="model == 3">
                    <v-row dense justify="center">
                      <v-col cols="12" align="center">
                        <ButtonHover :small="true" :plain="true" :icons="['mdi-power-on']" :command="'dabon'" :span="''"> </ButtonHover>
                        <ButtonHover :small="true" :plain="true" :icons="['mdi-power-off']" :command="'daboff'" :span="''"> </ButtonHover>
                      </v-col>
                    </v-row>
                  </template>
                  <!-- Single DABs -->
                  <template v-if="model == 4">
                    <v-row v-for="(item, index) in dab" :key="index" dense justify="center">
                      <v-col cols="auto" align="center">
                        <ButtonHover class="ma-0 pa-0" :small="true" :plain="true" :icons="['mdi-power-on']" :command="'dab' + (parseInt(index) + 1).toString() + 'on'" :span="''"> </ButtonHover>
                        <ButtonHover class="ma-0 pa-0" :small="true" :plain="true" :icons="['mdi-power-off']" :command="'dab' + (parseInt(index) + 1).toString() + 'off'" :span="''"> </ButtonHover>
                        <ButtonHover class="ma-0 pa-0" :small="true" :plain="true" :icons="['mdi-medical-bag']" :command="'clearerrordab' + (parseInt(index) + 1).toString()" :span="''"> </ButtonHover>
                        <ButtonHover class="ma-0 pa-0" :small="true" :plain="true" :icons="['mdi-battery-medium', 'mdi-restore']" :command="'dab' + (parseInt(index) + 1).toString() + 'softreset'" span="SOFT"> </ButtonHover>
                        <ButtonHover class="ma-0 pa-0" :small="true" :plain="true" :icons="['mdi-battery-medium', 'mdi-restore']" :command="'dab' + (parseInt(index) + 1).toString() + 'hardreset'" span="HARD"> </ButtonHover>
                      </v-col>
                    </v-row>
                  </template>
                  <!-- Others -->

                  <template v-if="model == 5">
                    <v-row dense justify="center">
                      <v-col cols="12" align="center">
                        <ButtonHover :small="true" :plain="true" :icons="['mdi-wrench']" :command="'servicemode'" :span="''"> </ButtonHover>
                        <ButtonHover :small="true" :plain="true" :icons="['mdi-battery-heart']" :command="'format'" :span="''"> </ButtonHover>
                        <ButtonHover :small="true" :plain="true" :icons="['mdi-medical-bag']" :command="'clearerror'" :span="''"> </ButtonHover>
                      </v-col>

                      <v-col cols="12" align="center">
                        <ButtonHover :small="true" :plain="true" :icons="['mdi-current-ac', 'mdi-restore']" :command="'invertersoftreset'" :span="'SOFT'"> </ButtonHover>
                        <ButtonHover :small="true" :plain="true" :icons="['mdi-current-ac', 'mdi-restore']" :command="'inverterhardreset'" :span="'HARD'"> </ButtonHover>
                      </v-col>
                      <v-col cols="12" align="center">
                        <ButtonHover :small="true" :plain="true" :icons="['mdi-white-balance-sunny', 'mdi-restore']" :command="'mppthardreset'" :span="'HARD'"> </ButtonHover>
                      </v-col>
                    </v-row>
                  </template>
                </h3>
              </v-row>
            </v-sheet>
          </v-expand-transition>
        </v-sheet>
      </div>
    </template>
  </div>
</template>

<script>
import ButtonHover from "../../components/button/ButtonHover.vue";

import { ServiceClient } from "../../service_client/index.js";

export default {
  name: "BottomNavigationControl",
  components: {
    ButtonHover,
  },
  props: {
    dab: {
      type: Array,
      require: true,
    },
    mppt: {
      type: Array,
      require: true,
    },
    panel: {
      type: Boolean,
      require: false,
      default: true,
    },
  },
  data() {
    return {
      model: null,

      value: 0,
      active: true,
    };
  },
  methods: {
    sendCommand(value) {
      ServiceClient.dataCore(ServiceClient.getAPIUrl("command"), null, "?cmd=" + value, "GET").catch((error) => {
        ServiceClient.handleUnauthorized(error, this.$router);
      });
    },
  },
  watch: {
    value: function () {
      setTimeout(() => {
        this.value = 0;
      }, 1000);
    },
  },
};
</script>

<style scoped></style>
